import React, { FC, ReactNode } from 'react';
import { DatePicker, DatePickerProps } from '@heroui/date-picker';
import { DateValue } from '@internationalized/date';
import Label from '../label';
import { Container, PickerWrapper } from './styles';

type DatePickerCustomProps = {
  title?: string;
  required?: boolean;
  toolTip?: boolean;
  tooltipText?: ReactNode;
  containerClassName?: string;
  wrapperClassName?: string;
} & DatePickerProps<DateValue>;

const DatePickerCustom: FC<DatePickerCustomProps> = ({
  title,
  required,
  toolTip,
  tooltipText,
  containerClassName,
  wrapperClassName,
  ...datePickerProps
}) => (
  <Container className={containerClassName}>
    {title ? (
      <Label
        required={required}
        toolTip={toolTip}
        tooltipText={tooltipText}
        title={title}
      />
    ) : null}
    <PickerWrapper className={wrapperClassName}>
      <DatePicker
        variant="bordered"
        classNames={{
          base: 'w-full',
        }}
        {...datePickerProps}
      />
    </PickerWrapper>
  </Container>
);

export default DatePickerCustom;
export type { DatePickerCustomProps };
